import { getDefaultConfig } from '@guiker/config'

export const config = {
  ...getDefaultConfig('listing-inquiry'),
}

export enum MultipostInquiryChannel {
  craigslist = 'reply.craigslist.org',
}
